<template>
  <div>
    <el-button
      @click="dialogTableVisibletextarea = true"
      plain
      style="position: absolute;"
      type="single-number"
    >
      选择编码
    </el-button>
    <el-dialog
      :visible.sync="dialogTableVisibletextarea"
      custom-class="sorting-code-number"
      maxHeight="null"
      title="税收分类编码查询"
      width="990px"
    >
      <div class="el-dialog__body-header">
        <span class="title">税收分类</span>
        <el-search
          :formProp="form"
          :showIndex="showIndex"
          @change="change"
          @search="search"
          placement="bottom-start"
          width="380px"
        >
          <template slot="search">
            <el-input
              clearable
              placeholder="请输入内容"
              searchLabel="工龄"
              v-model="form.workYears"
            ></el-input>
            <el-input
              clearable
              placeholder="请输入内容"
              searchLabel="用户名"
              v-model="form.userName"
            ></el-input>
          </template>
        </el-search>
      </div>
      <div class="el-dialog__body-bodys">
        <div class="bodys-right">
          <el-table
            :data="tableData"
            :lineClamp="lineClampBody"
            maxHeight="390"
            style="width: 950px"
          >
            <el-table-column label="工龄" prop="workYears" width="180">
            </el-table-column>
            <el-table-column label="用户名" prop="userName"></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              label="身份证号"
              prop="idNum"
            >
            </el-table-column>
            <el-table-column label="操作" width="70">
              <template slot-scope="scope" style="margin-top: -11px">
                <el-button
                  :class="scope.row.button === false ? '' : 'checked'"
                  @click="handleClick(scope.row)"
                  plain
                  size="mini"
                  type="single-number-filleted"
                  >{{ scope.row.button === false ? "选择" : "已选择" }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="table-footer" style="height:30px">
            <div class="ccui-table-footer">
              <div id="ccui-paging">
                <el-pagination
                  :current-page="pageNoCode"
                  :page-size="pageSizeCode"
                  :pager-count="5"
                  :pagesize="pagesize"
                  :total="total"
                  @addCurrentPage="internalCurrentPage"
                  @current-change="handleCurrentChange"
                  @next-click="handleNext"
                  @prev-click="handlePrev"
                  @size-change="handleSizeChange"
                  background
                  layout="total, prev, pager, next, jumper"
                  next-text="下一页 >"
                  popper-class="ccui-paging-page-size-popper"
                  prev-text="< 上一页"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer" slot="footer">
        <el-button
          @click="dialogTableVisibletextarea = false"
          size="mini"
          type="default-mini"
          >取 消
        </el-button>
        <el-button
          @click="inventoryConfirm"
          size="mini"
          type="primary-font-mini"
          >确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listConSupPage } from "../../api/";

export default {
  data() {
    return {
      showIndex: 0,
      lineClampBody: true,
      tableData: [],
      searchData: [],
      treeProps: {
        label: "name",
        children: "zones",
        isLeaf: "leaf"
      },
      dialogTableVisibletextarea: false,
      form: {
        name: "",
        unifiedCode: "",
        supplierName: "",
        supplierCode: "",
        workYears: "",
        userName: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      textarea: "",
      formLabelWidth: "120px",
      pageSizeCode: 10,
      pageNoCode: 0,
      present: "",
      TableData: "",
      total: 0,
      lastTime: {
        button: false
      },
      pagesize: [10]
    };
  },
  methods: {
    inventoryConfirm() {
      this.dialogTableVisibletextarea = false;
      alert(JSON.stringify(this.TableData));
      this.$emit("inventoryConfirm", this.TableData);
    },
    listConSupPage(item, pageNo) {
      let data = {
        pageNo: pageNo ? pageNo : 1,
        userName: item.userName, // 用户名
        workYears: item.workYears // 工龄
      };
      listConSupPage(data).then(res => {
        this.TableData = "";
        this.tableData = res.data.data.rows;
        this.total = res.data.data.recordsTotal;
        this.tableData.map(e => {
          e.button = false;
          if (this.TableData.id === e.id) {
            e.button = true;
          }
        });
      });
    },
    handleClick(val) {
      this.TableData = val;
      val.button = true;
      if (val.id !== this.lastTime.id) {
        this.lastTime.button = false;
        this.lastTime = val;
      }
      this.tableData = [...this.tableData];
    },
    handleSizeChange(val) {},
    handleNodeClick(val) {
      this.$refs.tree.setCheckedKeys([]);
      this.$refs.tree.setCheckedKeys([val.id]);
    },
    handleCurrentChange(val) {
      this.listConSupPage(this.searchData, val);
    },
    internalCurrentPage(val) {
      val = 10;
    },
    handlePrev() {},
    handleNext() {},
    handleGoPage() {},
    search(searchData) {
      this.searchData = searchData;
      this.listConSupPage(searchData);
    },
    change(index, key, value) {
      this.showIndex = index;
    }
  }
};
</script>
